/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { B100, N10, N800, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { Link } from '../Router';

/**
 * @private
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WorkItemLink = styled(Link)`
	position: relative;
	margin: 0;
	overflow: hidden;
	display: block;
	padding-left: ${token('space.150', '12px')};
	padding-right: ${token('space.150', '12px')};
	border-radius: ${token('border.radius.100', '3px')};

	&:hover {
		background: ${token('color.background.neutral.subtle.hovered', N10)};
	}

	&:focus {
		outline: 0;
		box-shadow: 0 0 0 2px ${token('color.border.focused', B100)};
	}

	& + & {
		margin: ${token('space.050', '4px')} 0 0 0;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Content = styled.div`
	display: flex;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentIcon = styled.img`
	border-radius: ${token('border.radius.100', '3px')};
	display: flex;
	flex-shrink: 0;
	width: ${token('space.300', '24px')};
	height: ${token('space.300', '24px')};
	margin-top: ${token('space.100', '8px')};
	margin-bottom: ${token('space.100', '8px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Details = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: ${token('space.200', '16px')};
	justify-content: center;
	min-width: 0; // the min-width is necessary for the elipsis to appear
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DetailsHeadline = styled.div`
	padding-right: ${token('space.150', '12px')};
	padding-bottom: ${token('space.025', '2px')};
	display: flex;
	align-items: center;

	p {
		display: inline-block;
		font-size: 14px;
		line-height: 16px;
		margin: 0;
		color: ${token('color.text', N800)};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DetailsDescription = styled.p`
	font-size: 11px;
	line-height: 14px;
	color: ${token('color.text.subtlest', N90)};
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding-right: ${token('space.150', '12px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContainerName = styled.span`
	&:after {
		content: '\\00B7';
		padding-right: ${token('space.050', '4px')};
		padding-left: ${token('space.050', '4px')};
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.span``;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LozengeWrapper = styled.span`
	margin-left: ${token('space.050', '4px')};
`;
